import { type AxiosRequestConfig } from 'axios'
import HttpService from '@/common/services/HttpService'
import { type i18nMessagesDTOV2 } from '@/common/types/i18n'
import { type LocalizedMessagesV2Params } from '@/common/types/i18n'
import i18n from '@/plugins/i18n'

const { t } = i18n.global

export const labelWithPrefix = (prefix: string, text: string): string => {
  if (text.indexOf(prefix) > -1) return t(text)
  return t(prefix + text)
}

/**
 * Get localized messages for a given key
 */
export const getLocalizedMessagesV2 = (params: LocalizedMessagesV2Params, config: AxiosRequestConfig = {}): Promise<i18nMessagesDTOV2[]> => {
  return HttpService.getData<i18nMessagesDTOV2[]>('/api/v2/i18n-messages', {
    params,
    ...config,
  })
}

/**
 * Save localized messages for a given key
 */
export const saveLocalizedMessagesV2 = async (params: i18nMessagesDTOV2[]): Promise<i18nMessagesDTOV2[]> => {
  return await HttpService.putData<i18nMessagesDTOV2[]>(`/api/v2/bulk-i18n-messages`, params)
}
